import { render } from "./MenuSale.vue?vue&type=template&id=3295799b&scoped=true"
import script from "./MenuSale.vue?vue&type=script&lang=js"
export * from "./MenuSale.vue?vue&type=script&lang=js"

import "./MenuSale.vue?vue&type=style&index=0&id=3295799b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3295799b"]])

export default __exports__